import type {
  conditionFields,
  conditionOps,
  PolicyMode,
  PolicyModifications
} from "@veritrellis/shared";

export type ConditionField = (typeof conditionFields)[number];
export type ConditionOp = (typeof conditionOps)[number];
export type PolicyDecision = "allow" | "deny" | "require_approval";
export type PolicyRuleDecision =
  | "allow"
  | "deny"
  | "require_approval"
  | "require_modified_parameters";

export type BuilderCondition = {
  id: string;
  field: ConditionField;
  op: ConditionOp;
  value: string | number | string[];
};

export type BuilderRule = {
  id: string;
  conditions: BuilderCondition[];
  decision: PolicyRuleDecision;
  modifications?: PolicyModifications;
  approverGroupId?: string | null;
  permitTtlSeconds?: number | null;
};

export type BuilderState = {
  mode: PolicyMode;
  autoAllowLowRisk: boolean;
  rules: BuilderRule[];
  defaultDecision: PolicyDecision;
};

export const emptyCondition = (id: string): BuilderCondition => ({
  id,
  field: "amount",
  op: "gte",
  value: 0
});

export const emptyRule = (id: string): BuilderRule => ({
  id,
  conditions: [],
  decision: "require_approval"
});

export const defaultBuilderState = (): BuilderState => ({
  mode: "conditional",
  autoAllowLowRisk: false,
  rules: [emptyRule(crypto.randomUUID())],
  defaultDecision: "deny"
});
